export default <T>() => {
  let listeners: Function[] = [];

  const next = (arg: T) => listeners.forEach(fn => fn(arg));
  const subscribe = (fn: (arg: T) => void) => {
    listeners.push(fn);
    return () => unsubscribe(fn);
  };
  const unsubscribe = (fn: (arg: T) => void) =>
    (listeners = listeners.filter(v => v !== fn));

  return { next, subscribe, unsubscribe };
};
